import React from 'react';
import ReactDom from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import App from './components/app';
import {Provider} from 'react-redux';

import {createStore} from 'redux';
import {reducer} from './reducers'
import {PhoneProvider} from './components/phone-context';
import PhoneService from './service/phone-service';


const store = createStore(reducer);
const service=new PhoneService();

let shop=document.getElementById('main-content');

ReactDom.render(
    <Provider store={store}>
        <PhoneProvider value={service}>
            <Router>
                <App/>
            </Router>
        </PhoneProvider>
    </Provider>
, shop);